import { render, staticRenderFns } from "./SearchSortTag.vue?vue&type=template&id=315eaa87&scoped=true"
import script from "./SearchSortTag.vue?vue&type=script&lang=js"
export * from "./SearchSortTag.vue?vue&type=script&lang=js"
import style0 from "./SearchSortTag.vue?vue&type=style&index=0&id=315eaa87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315eaa87",
  null
  
)

export default component.exports